import { Injectable } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { Agent } from '@awork/features/agent/models/agent.model'

@Injectable({ providedIn: 'root' })
export class AgentStore extends EntitySignalStore<Agent> {
  constructor() {
    super({ name: 'agent', entityConstructor: agent => new Agent(agent) })
  }

  /**
   * Synchronizes an Agent unless it has been archived.
   * Archived Agents are removed so reactive consumers close or refresh instead
   * of displaying an Agent that is no longer active.
   * @param {Agent} agent Agent received from an incremental synchronization source.
   */
  syncEntity(agent: Agent): void {
    if (agent.isArchived) {
      this.remove(agent.id)

      return
    }

    super.syncEntity(agent)
  }
}
